<template>
    <span class="saveSuccessIndicator" v-show="value" :class="{ hiding }" @transitionend="doTransitionEnd">
        {{successText}}
    </span>
</template>

<script>
export default {
  name: 'saveSuccessIndicator',
  data: function() {
    return {
      hiding: false,
      timeout: null
    };
  },
  props: {
    value: Boolean,
    text: String
  },
  watch: {
    value(newVal) {
      if (newVal) {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.hiding = false;
        this.timeout = setTimeout(this.startHiding, 10000);
      }
    }
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  },
  methods: {
    startHiding() {
      this.timeout = null;
      this.hiding = true;
    },
    doTransitionEnd() {
      this.hiding = false;
      this.$emit('input', false);
    }
  },
  computed: {
    successText() {
      return this.text || this.$t('saveSuccess');
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .saveSuccessIndicator {
        color: $success;
        white-space: nowrap;
        overflow: hidden;
        max-width: 30em;
        opacity: 1;
        &.hiding {
            transition: all 1s;
            opacity: 0;
            max-width: 0px;
        }
    }
</style>
